import(/* webpackMode: "eager" */ "/app/src/sections/home/view/home-view.jsx");
